import * as types from "../actions/constants";

const INITIAL_STATE = {
    error_auth: {}
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.LOGIN_FAIL:
            return { ...state, error_auth: action.error.response.data };
        default:
            return state;
    }
}
